import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Privacy = () => {
  const { language, t } = useLanguage();

  const content = language === 'en' ? (
    <div className="space-y-8 text-gray-600 leading-relaxed">
      <p>Vacature.ai respects your privacy and is committed to protecting your personal data.</p>
      
      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Information We Collect</h2>
        <p className="mb-4">Vacature.ai may collect the following information when you use the platform:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>CV or resume files uploaded by users</li>
          <li>Professional experience and skills contained in CVs</li>
          <li>Technical information such as browser type, device type, and IP address</li>
          <li>Website usage data collected through analytics tools</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">How We Use Information</h2>
        <p className="mb-4">The information provided by users is used to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Analyze professional experience using AI technology</li>
          <li>Provide job matching and career insights</li>
          <li>Improve the performance and functionality of the platform</li>
          <li>Monitor and improve the user experience</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">CV Data Processing</h2>
        <p>CV files uploaded to vacature.ai may be temporarily processed by AI systems to analyze professional experience and skills.</p>
        <p className="mt-4">Uploaded CV data may be stored securely to improve matching results and platform functionality.</p>
        <p className="mt-4">Vacature.ai does not sell personal data to third parties.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Analytics</h2>
        <p>Vacature.ai may use analytics services such as Google Analytics to understand how users interact with the website and improve services.</p>
        <p className="mt-2">Analytics tools may collect anonymized usage information.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Data Security</h2>
        <p>Vacature.ai takes reasonable technical and organizational measures to protect user data.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">User Rights</h2>
        <p>Users may request access, correction, or deletion of their personal data by contacting the platform.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Contact</h2>
        <p>For privacy-related questions please contact:</p>
        <p className="font-bold mt-2">vacature.ai@gmail.com</p>
      </section>
    </div>
  ) : (
    <div className="space-y-8 text-gray-600 leading-relaxed">
      <p>Vacature.ai respecteert uw privacy en zet zich in voor de bescherming van uw persoonsgegevens.</p>
      
      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Informatie die wij verzamelen</h2>
        <p className="mb-4">Vacature.ai kan de volgende informatie verzamelen wanneer u het platform gebruikt:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>CV- of resume-bestanden geüpload door gebruikers</li>
          <li>Professionele ervaring en vaardigheden in CV's</li>
          <li>Technische informatie zoals browsertype, apparaattype en IP-adres</li>
          <li>Websitegebruiksgegevens verzameld via analytische tools</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Hoe we informatie gebruiken</h2>
        <p className="mb-4">De door gebruikers verstrekte informatie wordt gebruikt om:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Professionele ervaring te analyseren met behulp van AI-technologie</li>
          <li>Vacature-matching en loopbaanzichten te bieden</li>
          <li>De prestaties en functionaliteit van het platform te verbeteren</li>
          <li>De gebruikerservaring te monitoren en te verbeteren</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">CV-gegevensverwerking</h2>
        <p>CV-bestanden die naar vacature.ai worden geüpload, kunnen tijdelijk worden verwerkt door AI-systemen om professionele ervaring en vaardigheden te analyseren.</p>
        <p className="mt-4">Geüploade CV-gegevens kunnen veilig worden opgeslagen om matchresultaten en platformfunctionaliteit te verbeteren.</p>
        <p className="mt-4">Vacature.ai verkoopt geen persoonlijke gegevens aan derden.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Analyse</h2>
        <p>Vacature.ai kan analysediensten zoals Google Analytics gebruiken om te begrijpen hoe gebruikers met de website omgaan en om de diensten te verbeteren.</p>
        <p className="mt-2">Analysetools kunnen geanonimiseerde gebruiksinformatie verzamelen.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Gegevensbeveiliging</h2>
        <p>Vacature.ai neemt redelijke technische en organisatorische maatregelen om gebruikersgegevens te beschermen.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Gebruikersrechten</h2>
        <p>Gebruikers kunnen verzoeken om toegang, correctie of verwijdering van hun persoonsgegevens door contact op te nemen met het platform.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Contact</h2>
        <p>Voor privacygerelateerde vragen kunt u contact opnemen met:</p>
        <p className="font-bold mt-2">vacature.ai@gmail.com</p>
      </section>
    </div>
  );

  return (
    <div className="min-h-screen py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl font-black text-brand-dark mb-16 italic uppercase tracking-tighter">
          {t.legal.privacyTitle}
        </h1>
        <div className="bg-gray-50/50 p-12 lg:p-16 rounded-[3rem] border border-gray-100 shadow-sm">
          {content}
        </div>
      </div>
    </div>
  );
};

export default Privacy;